import api from '@/utils/api';

/**
 * Get Email Template
 * @returns {Promise}
 */
const getEmailTemplateApi = () => api.get('/user/my-account/email-template');
export default getEmailTemplateApi;
